// Shared MUI style tokens referencing CSS custom properties.
// Import these in any component that uses MUI sx props.

export const colors = {
  bgPage:        'var(--color-bg-page)',
  bgCard:        'var(--color-bg-card)',
  bgInput:       'var(--color-bg-input)',
  bgElevated:    'var(--color-bg-elevated)',
  bgSubtle:      'var(--color-bg-subtle)',
  textPrimary:   'var(--color-text-primary)',
  textSecondary: 'var(--color-text-secondary)',
  textMuted:     'var(--color-text-muted)',
  textFaint:     'var(--color-text-faint)',
  textOnAccent:  'var(--color-text-on-accent)',
  accent:        'var(--color-accent-primary)',
  accentHover:   'var(--color-accent-primary-hover)',
  secondary:     'var(--color-accent-secondary)',
  secondaryLight:'var(--color-accent-secondary-light)',
  info:          'var(--color-accent-info)',
  infoHover:     'var(--color-accent-info-hover)',
  warning:       'var(--color-accent-warning)',
  error:         'var(--color-accent-error)',
  borderDefault: 'var(--color-border-default)',
  borderAccent:  'var(--color-border-accent)',
  borderAccentHover: 'var(--color-border-accent-hover)',
}

export const textFieldSx = {
  '& .MuiOutlinedInput-root': {
    backgroundColor: colors.bgInput,
    color: colors.textPrimary,
    '& fieldset': { borderColor: colors.borderAccent },
    '&:hover fieldset': { borderColor: colors.borderAccentHover },
    '&.Mui-focused fieldset': { borderColor: colors.borderAccentHover },
  },
  '& .MuiInputLabel-root': { color: colors.textMuted },
  '& .MuiInputLabel-root.Mui-focused': { color: colors.accent },
}

export const cardSx = {
  backgroundColor: colors.bgCard,
  color: colors.textPrimary,
  border: `1px solid ${colors.borderAccent}`,
  transition: 'all 0.3s ease',
}

export const dialogPaperSx = {
  backgroundColor: colors.bgCard,
  color: colors.textPrimary,
}

export const selectSx = {
  backgroundColor: colors.bgInput,
  color: colors.textPrimary,
  '& .MuiOutlinedInput-notchedOutline': { borderColor: colors.borderAccent },
  '&:hover .MuiOutlinedInput-notchedOutline': { borderColor: colors.borderAccentHover },
  '& .MuiSvgIcon-root': { color: colors.textMuted },
}
